import Globals from '../../../utils/Globals';
import ReportSavedModel from '../models/ReportSavedModel';
import MabinsoCollection from '../../app/models/MabinsoCollection';

class ReportSavedCollection extends MabinsoCollection<ReportSavedModel> {
    url = () => Globals.baseUrl + 'reportsSaved/reportSaved';
    model = ReportSavedModel;
}
export default ReportSavedCollection;
